import { ConfigProvider, theme } from 'antd';
import { createContext, type PropsWithChildren, useEffect, useState } from 'react';

interface ColorModeContextType {
  mode: string;
  setMode: (mode: string) => void;
}

export const ColorModeContext = createContext<ColorModeContextType>({} as ColorModeContextType);

// eslint-disable-next-line react/prop-types
export const ColorModeContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const colorModeFromLocalStorage = localStorage.getItem('colorMode');
  const isSystemPreferenceDark = window?.matchMedia('(prefers-color-scheme: dark)').matches;
  const systemPreference = isSystemPreferenceDark ? 'dark' : 'light';
  const [mode, setMode] = useState(colorModeFromLocalStorage || systemPreference);

  useEffect(() => {
    window.localStorage.setItem('colorMode', mode);
  }, [mode]);

  const setColorMode = () => {
    if (mode === 'light') {
      setMode('dark');
    } else {
      setMode('light');
    }
  };

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', mode);
  }, [mode]);

  const { darkAlgorithm, defaultAlgorithm } = theme;

  return (
    <ColorModeContext.Provider
      value={{
        setMode: setColorMode,
        mode,
      }}>
      <ConfigProvider
        // you can change the theme colors here. example: ...RefineThemes.Magenta,
        theme={{
          token: {
            colorPrimary: '#4980cc',
          },
          algorithm: mode === 'light' ? defaultAlgorithm : darkAlgorithm,
        }}>
        {children}
      </ConfigProvider>
    </ColorModeContext.Provider>
  );
};
